import React from "react";

const Heading = () => {
  return (
    <div>
      <h2>Расчитайте стоимость автомобиля в лизинг</h2>
    </div>
  );
};

export default Heading;